import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import { getCreatorPosts } from '../lib/adminapi';
import { useGlobalContext } from '../context/AdminGlobalProvider';
import VentsCard from '../components/ventscard';
import EmptyState from '../components/emptystate';
import EventModal from '../components/eventModal';
import Footer2 from '../components/footer2';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';


// Import the modal component

function AdminProfile() {
    const { setCreator, creator, } = useGlobalContext();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null); // State to manage selected event
    const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility

    const locations = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (locations.search) {
            const searchParams = new URLSearchParams(locations.search);
            const respStatus = searchParams.get('respStatus');
            const tranRef = searchParams.get('tranRef');

            if (respStatus) {
                switch (respStatus) {
                    case 'A':
                        Swal.fire({
                            icon: 'success',
                            title: 'Payment Successful',
                            text: 'Your event has been featured!',
                        });
                        break;
                    case 'C':
                        Swal.fire({
                            icon: 'info',
                            title: 'Payment Canceled',
                            text: 'You have canceled the payment.',
                        });
                        break;
                    case 'D':
                    case 'E':
                    case 'V':
                    case 'X':
                        Swal.fire({
                            icon: 'error',
                            title: 'Payment Failed',
                            text: 'Please try again.',
                        });
                        break;
                    case 'H':
                        Swal.fire({
                            icon: 'info',
                            title: 'Payment On Hold',
                            text: 'Please contact us.',
                        });
                        break;
                    case 'P':
                        Swal.fire({
                            icon: 'info',
                            title: 'Payment Pending',
                            text: 'Please contact us.',
                        });
                        break;
                    default:
                        break;
                }

                // Optionally remove the query params from the URL after we handle them
                // so it doesn't keep popping up on refresh
                navigate(window.location.pathname, { replace: true });
            }
        }
    }, [locations, navigate]);

    useEffect(() => {
        const storedCreator = localStorage.getItem('creator');
        if (!creator && storedCreator) {
            setCreator(JSON.parse(storedCreator));
        }

        const fetchPosts = async () => {
            if (creator?.id) {
                try {
                    const result = await getCreatorPosts(creator.id);
                    setPosts(result);
                } catch (error) {
                    console.error("Error fetching posts:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchPosts();
    }, [creator, setCreator]);



    const openModal = (event) => {
        setSelectedEvent(event);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedEvent(null);
    };

    return (
        <div className="flex flex-col bg-[#211d3a] h-screen overflow-x-hidden">
            <Header />
            <div className="flex-grow flex-col flex justify-center items-center bg-[#211d3a8] p-4 ">


                <div className="w-full flex flex-col items-center ">
                    <h2 className="text-white text-3xl ">Your Events</h2>
                    {loading ? (
                        <p className="text-white">Loading events...</p>
                    ) : posts.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6 pb-16">
                            {posts.map((item) => (
                                <VentsCard key={item.id} event={item} onOpenModal={openModal} />
                            ))}
                        </div>
                    ) : (
                        <EmptyState title="No Events Found" />
                    )}
                </div>
            </div>
            {/* Modal for event details */}
            {isModalOpen && (
                <EventModal event={selectedEvent} isOpen={isModalOpen} onClose={closeModal} />
            )}
            <Footer2 />
        </div>
    );
}

export default AdminProfile;

